import { create } from 'zustand';
import { sidebarService } from '@/services/sidebarService';
import { showToast } from '@/lib/toast';
import {
    SidebarWithDetails,
    UpdateSidebarDto
} from '@/types/sidebar';

interface SidebarState {
    // Sidebar data
    sidebar: SidebarWithDetails | null;
    isLoading: boolean;
    isUpdating: boolean;
    error: string | null;

    // Actions
    fetchSidebar: () => Promise<void>;
    updateSidebar: (updateSidebarDto: UpdateSidebarDto) => Promise<void>;
    clearError: () => void;
    resetSidebar: () => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
    // Initial state
    sidebar: null,
    isLoading: false,
    isUpdating: false,
    error: null,

    // Actions
    fetchSidebar: async () => {
        set({ isLoading: true, error: null });
        try {
            const sidebar = await sidebarService.getSidebar();
            set({ sidebar, isLoading: false });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Lỗi khi tải sidebar';
            set({
                error: errorMessage,
                isLoading: false
            });
            showToast.error("Lỗi", errorMessage);
        }
    },

    updateSidebar: async (updateSidebarDto: UpdateSidebarDto) => {
        set({ isUpdating: true, error: null });
        try {
            const updatedSidebar = await sidebarService.updateSidebar(updateSidebarDto);
            set({ sidebar: updatedSidebar, isUpdating: false });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Lỗi khi cập nhật sidebar';
            set({
                error: errorMessage,
                isUpdating: false
            });
            showToast.error("Lỗi", errorMessage);
            throw error;
        }
    },

    clearError: () => set({ error: null }),
    resetSidebar: () => set({
        sidebar: null,
        error: null
    }),
}));
